"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(credits) {
    var options = { enabled: false };
    if (credits) {
        var defaultX = -10;
        var defaultY = -5;
        var _a = credits.props, align = _a.align, verticalAlign = _a.verticalAlign, x = _a.x, y = _a.y, overrides = __rest(_a, ["align", "verticalAlign", "x", "y"]);
        var position = {
            align: align || 'right',
            verticalAlign: verticalAlign || 'bottom',
            x: x || defaultX,
            y: y || defaultY
        };
        overrides.position = position;
        options = __assign(__assign({}, options), overrides);
    }
    return options;
}
exports.default = default_1;
//# sourceMappingURL=creditsOptions.js.map